import * as statements from '../../statements';
import { FactName } from '../../../../../api-types';
const { isFactType } = statements;
export const TRY = (args) => isFactType(FactName.TRY)(args.fact);
export const PENALTY_GOAL = (args) => isFactType(FactName.PENALTY_GOAL)(args.fact);
export const DROP_GOAL = (args) => isFactType(FactName.DROP_GOAL)(args.fact);
/*export const PLAYER_MILESTONE = (args: SequenceTriggerArgs): [boolean, any?] => isPlayerMilestone(args);*/
export const CONVERSION_MADE = (args) => isFactType(FactName.GOAL_KICK_SCORED)(args.fact);
/*export const TEAM_COMPARISON_MILESTONE = (args: SequenceTriggerArgs): [boolean, any?] =>
  isTeamComparisonMilestone(args);*/
//# sourceMappingURL=live.js.map